import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';

import * as fromState from './api-client-setting.state';
import * as fromReducer from './api-client-setting.reducer';

import { LocationsRouterStoreSelectors } from '../router';

import { ApiClientCredential } from '@era/settings-sdk';

export const selectApiClientSettingState: Selector<object, fromState.ApiClientSettingState> =
  createFeatureSelector<fromState.ApiClientSettingState>('apiClientSetting');

export const selectApiClientSettingIds: Selector<object, string[] | number[]> = createSelector(
  selectApiClientSettingState,
  fromReducer.selectApiClientSettingIds
);

export const selectApiClientSettingEntities: Selector<object, Dictionary<ApiClientCredential>> = createSelector(
  selectApiClientSettingState,
  fromReducer.selectApiClientSettingEntities
);

export const selectAllApiClientSettings: Selector<object, ApiClientCredential[]> = createSelector(
  selectApiClientSettingState,
  fromReducer.selectAllApiClientSettings
);

export const selectCurrentApiClientSetting: Selector<object, ApiClientCredential> = createSelector(
  LocationsRouterStoreSelectors.selectClientConfigurationId,
  selectApiClientSettingEntities,
  (settingId, settings) => settings[settingId]
);

export const selectAllApiClientSettingsLoaded: Selector<object, boolean> = createSelector(
  selectAllApiClientSettings,
  (settings) => settings && settings.length > 0
);
